module.exports = __webpack_public_path__ + "img/engine.17e4ff10.svg";